import Breakpoint from "./breakpoint";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default el => {

	const breakpoint =  new Breakpoint(768);

	breakpoint.above = () => {
		const img = el.querySelector('img, video');
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				scrub: true,
				pin: false,
			}
		});

		tl.fromTo(img, {
			yPercent: -10,
			ease: 'none'
		}, {
			yPercent: 10,
			ease: 'none'
		});
	}
};